import React from 'react';

import { Button } from 'reactstrap';
const BookRequestModal = () => {
  return (
    <div
      style={{
        textAlign: 'center',
        color: 'white',
        width: '160px',
        height: '44px',
        marginLeft: '0px',
      }}
    >
      <Button style={{ background: '#714FFF', borderColor: '#714FFF' }}>
        Book Request
      </Button>
    </div>
  );
};

export default BookRequestModal;
